import React, { useState, useEffect } from 'react';
import { FaCoins, FaStopwatch, FaClock, FaAd } from 'react-icons/fa';
import Calling from '../../../api/Calling';
import Navbar from '../../Quiz/Navbar';
import { toast } from 'react-toastify';

const TapToEarn = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [data, setData] = useState({
        tapCountStart: 5,
        tapCountEnd: 10,
        coin: 2,
        tap_timingStart: 3,
        tap_timingEnd: 5,
        tap_limit: 100,
        ad_position: 10,
        timeout_timing: 60
    });
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            const resp = await Calling.getTapToEarn();
            if (resp?.status) {
                // Handle the case where API returns old format with tap_timing
                if (resp.data.tap_timing && !resp.data.tap_timingStart && !resp.data.tap_timingEnd) {
                    // Convert old format to new format
                    resp.data.tap_timingStart = resp.data.tap_timing;
                    resp.data.tap_timingEnd = resp.data.tap_timing + 2; // Default end value
                    delete resp.data.tap_timing;
                }
                setData(resp.data);
                setError(null);
            } else {
                setError(resp?.message || 'Failed to fetch data');
            }
        } catch (error) {
            console.error(error);
            setError('Failed to fetch data. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        // Convert string values to numbers
        setData({
            ...data,
            [name]: parseInt(value, 10) || 0
        });
    };
    const handleSubmit = async () => {
        setSaving(true);
        setError(null);
        setSuccess(null);

        // Validation
        if (!(data.tapCountStart < data.tapCountEnd)) {
            setSaving(false);
            return toast.error("Tap Starting Count must be less than Tap Ending Count.");
        }

        if (!(data.tap_timingStart < data.tap_timingEnd)) {
            setSaving(false);
            return toast.error("Tap Timing Start must be less than Tap Timing End.");
        }

        try {
            const body = {
                tapCountStart: data.tapCountStart,
                tapCountEnd: data.tapCountEnd,
                coin: data.coin,
                tap_timingStart: data.tap_timingStart,
                tap_timingEnd: data.tap_timingEnd,
                tap_limit: data.tap_limit,
                ad_position: data.ad_position,
                timeout_timing: data.timeout_timing
            };

            const resp = await Calling.putTapToEarn(body);

            if (resp?.status) {
                setSuccess("Settings updated successfully!");
                toast.success("Settings updated successfully!");
                setTimeout(() => setSuccess(null), 3000);
            } else {
                setError(resp?.message || "Failed to update settings.");
                toast.error(resp?.message || "Failed to update settings.");
            }
        } catch (error) {
            console.error(error);
            setError("Failed to update settings. Please try again.");
            toast.error("Failed to update settings. Please try again.");
        } finally {
            setSaving(false);
        }
    }

    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-main-blue"></div>
            </div>
        );
    }

    return (
        <div className="w-full text-main-font mt-16 px-3 md:ml-[4.4rem]">
            <h1 className="text-xl md:text-2xl font-bold mt-4 text-main-font w-auto">Tap To Earn Management</h1>
            <div className='bg-main-white rounded-xl shadow-lg'>
                <Navbar selectState={'tap'} />
                <hr className='border-main-border' />
                <div className="p-6">
                    {error && (
                        <div className="mb-4 p-3 bg-red-50 text-main-delete rounded-md border border-red-200">
                            {error}
                        </div>
                    )}

                    {success && (
                        <div className="mb-4 p-3 bg-green-50 text-green-700 rounded-md border border-green-200">
                            {success}
                        </div>
                    )}

                    <div className="bg-main-bg rounded-xl p-5 border border-main-border">
                        <h2 className="text-lg font-semibold mb-4 text-main-font">Configure Settings</h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                            <div>
                                <label className="block text-main-font mb-2" htmlFor="tapCountStart">
                                    <div className="flex items-center">
                                        <FaStopwatch className="mr-2 text-main-blue" /> Tap Count Start
                                    </div>
                                </label>
                                <input
                                    type="number"
                                    id="tapCountStart"
                                    name="tapCountStart"
                                    value={data.tapCountStart}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-main-border rounded-md focus:outline-none focus:ring-2 focus:ring-main-blue"
                                    min="1"
                                    onWheel={(e) => e.target.blur()}
                                />
                                <p className="text-sm text-main-subfont mt-1">Minimum number of taps required</p>
                            </div>

                            <div>
                                <label className="block text-main-font mb-2" htmlFor="tapCountEnd">
                                    <div className="flex items-center">
                                        <FaStopwatch className="mr-2 text-main-blue" /> Tap Count End
                                    </div>
                                </label>
                                <input
                                    type="number"
                                    id="tapCountEnd"
                                    name="tapCountEnd"
                                    value={data.tapCountEnd}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-main-border rounded-md focus:outline-none focus:ring-2 focus:ring-main-blue"
                                    min={data.tapCountStart + 1}
                                    onWheel={(e) => e.target.blur()}
                                />
                                <p className="text-sm text-main-subfont mt-1">Maximum number of taps required</p>
                            </div>



                            <div>
                                <label className="block text-main-font mb-2" htmlFor="tap_timingStart">
                                    <div className="flex items-center">
                                        <FaClock className="mr-2 text-main-blue" /> Tap Timing Start (seconds)
                                    </div>
                                </label>
                                <input
                                    type="number"
                                    id="tap_timingStart"
                                    name="tap_timingStart"
                                    value={data.tap_timingStart}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-main-border rounded-md focus:outline-none focus:ring-2 focus:ring-main-blue"
                                    min="1"
                                    onWheel={(e) => e.target.blur()}
                                />
                                <p className="text-sm text-main-subfont mt-1">Minimum time allowed for tapping (seconds)</p>
                            </div>

                            <div>
                                <label className="block text-main-font mb-2" htmlFor="tap_timingEnd">
                                    <div className="flex items-center">
                                        <FaClock className="mr-2 text-main-blue" /> Tap Timing End (seconds)
                                    </div>
                                </label>
                                <input
                                    type="number"
                                    id="tap_timingEnd"
                                    name="tap_timingEnd"
                                    value={data.tap_timingEnd}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-main-border rounded-md focus:outline-none focus:ring-2 focus:ring-main-blue"
                                    min={data.tap_timingStart + 1}
                                    onWheel={(e) => e.target.blur()}
                                />
                                <p className="text-sm text-main-subfont mt-1">Maximum time allowed for tapping (seconds)</p>
                            </div>

                            <div>
                                <label className="block text-main-font mb-2" htmlFor="coin">
                                    <div className="flex items-center">
                                        <FaCoins className="mr-2 text-main-blue" /> Coins
                                    </div>
                                </label>
                                <input
                                    type="number"
                                    id="coin"
                                    name="coin"
                                    value={data.coin}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-main-border rounded-md focus:outline-none focus:ring-2 focus:ring-main-blue"
                                    min="1"
                                    onWheel={(e) => e.target.blur()}
                                />
                                <p className="text-sm text-main-subfont mt-1">Coins awarded per tap session</p>
                            </div>

                            <div>
                                <label className="block text-main-font mb-2" htmlFor="tap_limit">
                                    <div className="flex items-center">
                                        <FaStopwatch className="mr-2 text-main-blue" /> Tap Limit
                                    </div>
                                </label>
                                <input
                                    type="number"
                                    id="tap_limit"
                                    name="tap_limit"
                                    value={data.tap_limit}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-main-border rounded-md focus:outline-none focus:ring-2 focus:ring-main-blue"
                                    min="1"
                                    onWheel={(e) => e.target.blur()}
                                />
                                <p className="text-sm text-main-subfont mt-1">Maximum taps allowed per session</p>
                            </div>

                            <div>
                                <label className="block text-main-font mb-2" htmlFor="ad_position">
                                    <div className="flex items-center">
                                        <FaAd className="mr-2 text-main-blue" /> Ad Position
                                    </div>
                                </label>
                                <input
                                    type="number"
                                    id="ad_position"
                                    name="ad_position"
                                    value={data.ad_position}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-main-border rounded-md focus:outline-none focus:ring-2 focus:ring-main-blue"
                                    min="1"
                                    onWheel={(e) => e.target.blur()}
                                />
                                <p className="text-sm text-main-subfont mt-1">Position to show (Fullscreen / Open) ads</p>
                            </div>

                            <div>
                                <label className="block text-main-font mb-2" htmlFor="timeout_timing">
                                    <div className="flex items-center">
                                        <FaStopwatch className="mr-2 text-main-blue" /> Timeout Timing (seconds)
                                    </div>
                                </label>
                                <input
                                    type="number"
                                    id="timeout_timing"
                                    name="timeout_timing"
                                    value={data.timeout_timing}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-main-border rounded-md focus:outline-none focus:ring-2 focus:ring-main-blue"
                                    min="1"
                                    onWheel={(e) => e.target.blur()}
                                />
                                <p className="text-sm text-main-subfont mt-1">Timeout between tap sessions</p>
                            </div>
                        </div>

                        <div className="flex justify-end">
                            <button
                                onClick={handleSubmit}
                                disabled={saving}
                                className={`px-6 py-2.5 rounded-lg text-white ${saving ? 'bg-opacity-70' : 'hover:bg-[#5A3DEE] transform hover:scale-[1.02]'
                                    } bg-main-blue transition-all shadow-md focus:outline-none focus:ring-2 focus:ring-main-blue flex items-center`}
                            >
                                {saving ? (
                                    <>
                                        <span className="mr-2 inline-block h-4 w-4 rounded-full border-2 border-white border-t-transparent animate-spin"></span>
                                        Saving...
                                    </>
                                ) : (
                                    'Save Changes'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TapToEarn;